import { Type as ServerVoteType } from '@wix/ambassador-comments-v1-vote/types';
import { assertFields } from '../../../ts-utils';
export const fromServerVote = (vote) => {
    assertFields(vote, ['resourceId', 'voteId', 'type'], 'vote');
    return {
        commentId: vote.resourceId,
        voteId: vote.voteId,
        type: vote.type === ServerVoteType.DOWNVOTE ? 'DOWNVOTE' : 'UPVOTE',
    };
};
export const fromServerVotes = (votes) => {
    return (votes || [])
        .filter((v) => v && v.type && v.type !== ServerVoteType.UNKNOWN)
        .map(fromServerVote);
};
//# sourceMappingURL=vote-service-mappers.js.map